'use strict';

angular.module('far.admin')
	.controller('NewsArchiveEditController', function (NewsArchive, newsArchiveForm, showModalMessage) {
		var vm = {
			progress: true,
			submitted: false,
			form: {},
			fields: newsArchiveForm,
			constructor: function (newsArchive) {
				if ( newsArchive ) {
					vm.form = NewsArchive.get(newsArchive, function() {
						if ( !vm.form.parent ) {
							vm.form.parent = {
								id: 0,
								parent_id: null
							}
						}

						vm.progress = false;
					});
				} else {
					vm.form = NewsArchive.new();
                    vm.form.sortable = 0;

					vm.progress = false;
				}
			},
			submit: function () {
				vm.form.save()
					.then(function (response) {
						document.location.href=Routing.generate('news_archive_view', {id: response.data.id});
					})
					.catch(function (response) {
						$log.error(response);
						showModalMessage('Не удалось сохранить изменения на сервере. Попробуйте повторить попытку через некоторое время.');
					});
			}
		};

		return vm;
	});
